import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class OvertimeDrive extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.EndOfPlay &&
            gameContext.getOvertimePeriod() &&
            gameContext.getDriveContext().triggerDrive
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamHasPossession } = play.getContextSnapshot();
        if (homeTeamHasPossession) {
            gameContext.homeTeamOvertimeDrive = true;
        } else {
            gameContext.awayTeamOvertimeDrive = true;
        }
        ruleContext.setResetField(true);
    }
}
